export class OrganizationUpdateProfileImage {
  file!: File;
}
